<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import Vue from 'vue';
import vSelect from 'vue-select';
import EmptyLayout from '@/layouts/EmptyLayout';
import MainLayout from '@/layouts/MainLayout';
import IndexLayout from '@/layouts/IndexLayout';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@fortawesome/fontawesome-free/css/all.css';
import 'vue-select/dist/vue-select.css';
import { mapGetters } from 'vuex';
import ClickOutside from 'vue-click-outside';
import OpenIndicator from '@/components/form/components/OpenIndicator.vue';

vSelect.props.components.default = () => ({ OpenIndicator });

library.add(faUserSecret);
Vue.component('v-select', vSelect);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.directive('click-outside', ClickOutside);

export default {
  async created() {
    if (this.hasToken) {
      await this.$store.dispatch('getProfile');
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout';
    },
    ...mapGetters({
      hasToken: 'hasToken',
    }),
  },
  components: {
    IndexLayout,
    EmptyLayout,
    MainLayout,
  },
};
</script>

<style>
.hovered-dark-icon path,
.hover-dark-icon:hover path {
  @apply fill-current text-gray-500;
}
</style>
